'use strict';

/**
 * @module
 * @author Oleg Dutchenko <dutchenko.o.dev@gmail.com>
 * @version 1.0.0
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import {AbstractSelect2} from './abstract';

// ----------------------------------------
// Public
// ----------------------------------------

$.fn.select2.amd.define('select2/data/customAdapter', ['select2/data/array', 'select2/utils'],
    function (ArrayData, Utils) {
        function CustomDataAdapter($element, options) {
            CustomDataAdapter.__super__.constructor.call(this, $element, options);
        }

        Utils.Extend(CustomDataAdapter, ArrayData);

        CustomDataAdapter.prototype.current = function (callback) {
            var found = [],
                findValue = null,
                initialValue = this.options.options.initialValue,
                selectedValue = this.$element.val(),
                jsonData = this.options.options.jsonData,
                jsonMap = this.options.options.jsonMap;

            if (initialValue !== null){
                findValue = initialValue;
                this.options.options.initialValue = null;  // <-- set null after initialized
            }
            else if (selectedValue !== null){
                findValue = selectedValue;
            }

            if(!this.$element.prop('multiple')){
                findValue = [findValue];
                this.$element.html();     // <-- if I do this for multiple then it breaks
            }

            // Query value(s)
            for (var v = 0; v < findValue.length; v++) {
                for (var i = 0, len = jsonData.length; i < len; i++) {
                    if (findValue[v] == jsonData[i][jsonMap.id]){
                        found.push({id: jsonData[i][jsonMap.id], text: jsonData[i][jsonMap.text]});
                        if(this.$element.find("option[value='" + findValue[v] + "']").length == 0) {
                            this.$element.append(new Option(jsonData[i][jsonMap.text], jsonData[i][jsonMap.id]));
                        }
                        break;
                    }
                }
            }

            // Set found matches as selected
            this.$element.find("option").prop("selected", false).removeAttr("selected");
            for (var v = 0; v < found.length; v++) {
                this.$element.find("option[value='" + found[v].id + "']").prop("selected", true).attr("selected","selected");
            }

            // If nothing was found, then set to top option (for single select)
            if (!found.length && !this.$element.prop('multiple')) {  // default to top option
                found.push({id: jsonData[0][jsonMap.id], text: jsonData[0][jsonMap.text]});
                this.$element.html(new Option(jsonData[0][jsonMap.text], jsonData[0][jsonMap.id], true, true));
            }

            callback(found);
        };

        CustomDataAdapter.prototype.query = function (params, callback) {
            if (!("page" in params)) {
                params.page = 1;
            }

            var jsonData = this.options.options.jsonData,
                pageSize = this.options.options.pageSize,
                jsonMap = this.options.options.jsonMap;

            var results = $.map(jsonData, function(obj) {
                // Search
                if(new RegExp(params.term, "i").test(obj[jsonMap.text])) {
                    return {
                        id:obj[jsonMap.id],
                        text:obj[jsonMap.text]
                    };
                }
            });

            callback({
                results:results.slice((params.page - 1) * pageSize, params.page * pageSize),
                pagination:{
                    more:results.length >= params.page * pageSize
                }
            });
        };

        return CustomDataAdapter;

    });

var jsonAdapter=$.fn.select2.amd.require('select2/data/customAdapter');

export class DefaultSelect2 extends AbstractSelect2 {
    /**
     * @type {Select2Props}
     */
    get defaultProps() {
        return super.defaultProps;
    }

    /**
     * @type {Select2Settings}
     */
    get defaultSettings() {
        const settings = {
            containerCssClass: 'custom-select2__select-container',
            dropdownCssClass: 'custom-select2__select-dropdown',
            width: '100%',
            closeOnSelect : true,
        };

        if (this.props.url) {
            const options = this.props.options || {};
            settings.minimumInputLength = 1;
            settings.ajax = {
                url: this.props.url,
                method: 'get',
                dataType: 'json',
                delay: 400,
                cache: true,
                data: function (params) {
                    const param = {
                        query: params.term || '',
                        page: params.page || 1
                    };
                    for (const key in options) {
                        param[key] = options[key];
                    }

                    return param;
                },
                processResults: function (data) {
                    const items = data.results.map((item) => ({
                        id: item.id,
                        text: item.name
                    }));
                    return {
                        results: items,
                        pagination: {
                            more: data.pagination.more || false
                        }
                    };
                }
            };
        }

        return Object.assign(settings, this.props);
    }

    /**
     * @protected
     */
    _afterInitialize() {
        super._afterInitialize();
        // const $control = this.$container.closest('[data-control]');
        const $product = this.$container.closest('[data-product]');
        const inProduct = !!$product;
        const $field = this.$container.closest('.form-item');
        const $body = $('body');

        this.$select.on('select2:opening', () => {
            this.$container.addClass('custom-select2--focused');
            $body.addClass('is-open-select');
            // $control.addClass('in-focus');

            inProduct && $product.addClass('is-active');
        });
        this.$select.on('select2:close', () => {
            this.$container.removeClass('custom-select2--focused');
            $body.removeClass('is-open-select');
            // $control.removeClass('in-focus');

            inProduct && $product.removeClass('is-active');
        });
        this.$select.on('select2:select', () => {
            $(window).data('select2Change', this.$select);
            $(document).trigger('select2Change');
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
        });
        this.$select.on('select2:unselect', () => {
            this.$container.removeClass('custom-select2--selected');
            $field.removeClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
        });

        this.$select.on('change', () => {
            $field.toggleClass('form-item--has-value', !!this.$select.val());
        });

        if (this.$select.val() && this.$select.val().length) {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            // $control.addClass('has-value');
        }
    }
}

export class MultipleSelect2 extends AbstractSelect2 {
    get defaultSettings() {
        let that = this;
        let timer = null;
        const settings = {
            width: '100%',
            multiple: true,
            minimumInputLength: 0,
            maximumSelectionLength: 2,
            minimumResultsForSearch: 5,
            ajax: {
                delay: 0,
                transport: function(params, success, failure) {
                    let pageSize = 10;
                    let term = (params.data.term || '').toLowerCase();
                    let page = (params.data.page || 1);

                    if (timer)
                        clearTimeout(timer);

                    timer = setTimeout(function(){
                        timer = null;
                        let array = Array.prototype.slice.call(that.$select[0].options)
                        let results = array.filter(function(f){
                            switch(that.props.filterType) {
                                case 'cities':
                                    let matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(term), "i");
                                    let text = $(f).text();
                                    return !term || matcher.test(text) || (text != null ? text.toLowerCase().indexOf('('+term.toLowerCase()) !== -1 : false)
                                default:
                                    return $(f).text().toLowerCase().includes(term);
                            }
                        })
                        .map(function(f){
                            return { id: $(f).val(), text: $(f).text()};
                        });

                        let paged = results.slice((page -1) * pageSize, page * pageSize);

                        let options = {
                            results: paged,
                            pagination: {
                                more: results.length >= page * pageSize
                            }
                        };
                        success(options);
                    }, params.delay);
                }
            },
        };

        if (this.clientProps.url) {
            const options = this.props.options || {};
            settings.minimumInputLength = 1;
            settings.ajax = {
                url: this.props.url,
                method: 'get',
                dataType: 'json',
                delay: 400,
                cache: true,
                data: function (params) {
                    const param = {
                        query: params.term || '',
                        page: params.page || 1
                    };
                    for (const key in options) {
                        param[key] = options[key];
                    }

                    return param;
                },
                processResults: function (data) {
                    const items = data.map((item) => ({
                        id: item['Id'],
                        text: item['Name']
                    }));
                    return {
                        results: items,
                        pagination: {
                            more: false
                        }
                    };
                },
                templateResult: function (data, container) {
                    $(data.element).attr('data-id', data.customValue);
                    return data.text;
                }
            };
        }

        return Object.assign(settings, this.props);
    }

    _afterInitialize() {
        super._afterInitialize();
        const $field = this.$container.closest('.form-item');



        this.$select.removeAttr('multiple');
        if (this.$select.options) {
            this.$select.val(null).trigger('change');
        }
        if (this.$select.val() && this.$select.val().length) {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            // $control.addClass('has-value');
        }

        let selectedValue = null;
        if (this.$container.hasClass('js-warehouse-select')) {
            this.$select.on('select2:selecting', (e) => {
                selectedValue = e.params.args.data.id;
            });

            this.$select.on('select2:close', () => {
                this.$select.val(selectedValue).trigger('change');
            });
        }

        this.$select.on('select2:open', () => {
            selectedValue = this.$select.val();
            this.$select.val(null).trigger('change');
        });

        this.$select.on('select2:select', () => {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
            $field.find('textarea').blur();
        });
        this.$select.on('change', () => {
            $field.toggleClass('form-item--has-value', !!this.$select.val());
        });
    }
}

export class SearchSelect2 extends AbstractSelect2 {
    get defaultSettings() {
        let that = this;
        let timer = null;
        const settings = {
            width: '100%',
            multiple: true,
            minimumInputLength: 0,
            maximumSelectionLength: 1,
            minimumResultsForSearch: 5,
            ajax: {
                delay: 0,
                transport: function(params, success, failure) {
                    let pageSize = 10;
                    let term = (params.data.term || '').toLowerCase();
                    let page = (params.data.page || 1);

                    if (timer)
                        clearTimeout(timer);

                    timer = setTimeout(function(){
                        timer = null;
                        let array = Array.prototype.slice.call(that.$select[0].options)
                        let results = array.filter(function(f){
                            switch(that.props.filterType) {
                                case 'cities':
                                    let matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(term), "i");
                                    let text = $(f).text();
                                    return !term || matcher.test(text) || (text != null ? text.toLowerCase().indexOf('('+term.toLowerCase()) !== -1 : false)
                                default:
                                    return $(f).text().toLowerCase().includes(term);
                            }
                        })
                            .map(function(f){
                                return { id: $(f).val(), text: $(f).text()};
                            });

                        let paged = results.slice((page -1) * pageSize, page * pageSize);

                        let options = {
                            results: paged,
                            pagination: {
                                more: results.length >= page * pageSize
                            }
                        };
                        success(options);
                    }, params.delay);
                }
            },
        };

        if (this.clientProps.url) {
            settings.minimumInputLength = 8;
            settings.ajax = {
                url: this.props.url,
                method: 'post',
                dataType: 'json',
                delay: 400,
                cache: false,
                data: function (params) {
                    return {
                        accountNumber: params.term || '',
                    };
                },
                processResults: function (data, params) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item === true || item === false ? null : item,
                                id: params.term,
                            };
                        })
                    };
                },
            };
        }

        return Object.assign(settings, this.props);
    }

    _afterInitialize() {
        super._afterInitialize();
        const $field = this.$container.closest('.form-item');



        this.$select.removeAttr('multiple');
        if (this.$select.options) {
            this.$select.val(null).trigger('change');
        }
        if (this.$select.val() && this.$select.val().length) {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            // $control.addClass('has-value');
        }

        let selectedValue = null;
        if (this.$container.hasClass('js-warehouse-select')) {
            this.$select.on('select2:selecting', (e) => {
                selectedValue = e.params.args.data.id;
            });

            this.$select.on('select2:close', () => {
                this.$select.val(selectedValue).trigger('change');
            });
        }

        this.$select.on('select2:open', () => {
            selectedValue = this.$select.val();
            this.$select.val(null).trigger('change');
        });

        this.$select.on('select2:select', () => {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
        });
        this.$select.on('change', () => {
            $field.toggleClass('form-item--has-value', !!this.$select.val());
        });
    }
}

export class SearchSitySelect2 extends AbstractSelect2 {
    get defaultSettings() {
        const settings = {
            width: '100%',
            multiple: true,
            minimumInputLength: 2,
            minimumResultsForSearch: 5,
            ajax: {
                delay: 250,
                dataType: "json",
                type: "get",
                url: this.props.url,
                data: function (params) {
                    return {
                        name: params.term
                    };
                },
                processResults: function (data) {
                    const items = data.map((item) => ({
                        text: item['Text'],
                        id: item['Value'],
                    }));
                    return {
                        results: items,
                        pagination:{
                            more: false
                        }
                    };
                }
            }
        };

        return Object.assign(settings, this.props);
    }

    _afterInitialize() {
        super._afterInitialize();
        const $field = this.$container.closest('.form-item');



        this.$select.removeAttr('multiple');
        if (this.$select.options) {
            this.$select.val(null).trigger('change');
        }
        if (this.$select.val() && this.$select.val().length) {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            // $control.addClass('has-value');
        }

        let selectedValue = null;
        if (this.$container.hasClass('js-warehouse-select')) {
            this.$select.on('select2:selecting', (e) => {
                selectedValue = e.params.args.data.id;
            });

            this.$select.on('select2:close', () => {
                this.$select.val(selectedValue).trigger('change');
            });
        }

        this.$select.on('select2:open', () => {
            selectedValue = this.$select.val();
            this.$select.val(null).trigger('change');
        });

        this.$select.on('select2:select', () => {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
        });
        this.$select.on('change', () => {
            $field.toggleClass('form-item--has-value', !!this.$select.val());
        });
    }
}

export class MultipleWarehouseSelect2 extends AbstractSelect2 {
    get defaultSettings() {
        let that = this;
        let timer = null;
        const settings = {
            width: '100%',
            multiple: true,
            minimumInputLength: 0,
            maximumSelectionLength: 2,
            minimumResultsForSearch: 5,
            templateResult: formatDesign,
            templateSelection:  formatState,
            ajax: {
                delay: 0,
                transport: function(params, success, failure) {
                    let pageSize = 10;
                    let term = (params.data.term || '').toLowerCase();
                    let page = (params.data.page || 1);

                    if (timer)
                        clearTimeout(timer);

                    timer = setTimeout(function(){
                        timer = null;
                        let array = Array.prototype.slice.call(that.$select[0].options)
                        let results = array.filter(function(f){
                            switch(that.props.filterType) {
                                case 'cities':
                                    let matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(term), "i");
                                    let text = $(f).text();
                                    return !term || matcher.test(text) || (text != null ? text.toLowerCase().indexOf('('+term.toLowerCase()) !== -1 : false)
                                default:
                                    return $(f).text().toLowerCase().includes(term);
                            }
                        }).map(function(f){
                            return { id: $(f).val(), text: $(f).text(), icon: $(f)[0].dataset.image};
                        });

                        let paged = results.slice((page -1) * pageSize, page * pageSize);

                        let options = {
                            results: paged,
                            pagination: {
                                more: results.length >= page * pageSize
                            }
                        };
                        success(options);
                    }, params.delay);
                }
            },
        };

        function formatDesign(item) {
            const selectionText = item.text.split("***");
            const image = item.icon;

            let tooltipWarehouseType;
            let translates = window.translates.tooltipWarehouseType;

            switch(image) {
                case 'warehouse1':
                    tooltipWarehouseType = translates.tooltipWarehouseType1
                    break;
                case 'warehouse3':
                    tooltipWarehouseType = translates.tooltipWarehouseType3
                    break;
                case 'warehouse0':
                    tooltipWarehouseType = translates.tooltipWarehouseType0
                    break;
            }

            if(selectionText[1]) {
                return $(`<span class="_flex _items-center">` + `<span class="${image === 'warehouse3' && 'warehouse3'}" data-title="${tooltipWarehouseType}"> <img width="20" height="22" class="_mr-sm _vw:mr-sm" src="/Images/UserArea/svg/${image}.svg" alt=""> </span>` + '<span>' + selectionText[0] + '</br>' + '<span class="option-sub">' + selectionText[1]+'</span>' +'</span>' + '</span>');
            } else {
                return $('<span>' + selectionText[0] + '</span>');
            }
        }
        function formatState (item) {
            const selectionText = item.text.split("***");

            if(selectionText[1]) {
                return $(`<span>` + selectionText[0] + '</br>' + '<span class="option-sub">' + selectionText[1]+'</span>' + '</span>');
            } else {
                return $('<span>' + selectionText[0] + '</span>');
            }
        }

        return Object.assign(settings, this.props);
    }

    _afterInitialize() {
        super._afterInitialize();
        const $field = this.$container.closest('.form-item');

        this.$select.removeAttr('multiple');
        if (this.$select.options) {
            this.$select.val(null).trigger('change');
        }
        if (this.$select.val() && this.$select.val().length) {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            // $control.addClass('has-value');
        }

        let selectedValue = null;
        if (this.$container.hasClass('js-warehouse-select')) {
            this.$select.on('select2:selecting', (e) => {
                selectedValue = e.params.args.data.id;
            });

            this.$select.on('select2:close', () => {
                this.$select.val(selectedValue).trigger('change');
            });
        }

        this.$select.on('select2:open', () => {
            selectedValue = this.$select.val();
            this.$select.val(null).trigger('change');
        });

        this.$select.on('select2:select', () => {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
            $field.find('textarea').blur();
        });
        this.$select.on('change', () => {
            $field.toggleClass('form-item--has-value', !!this.$select.val());
        });
    }
}

export class EmployeeSelect2 extends AbstractSelect2 {
    get defaultSettings() {
        let that = this;
        let timer = null;
        const settings = {
            width: '100%',
            multiple: true,
            minimumInputLength: 0,
            maximumSelectionLength: 1,
            minimumResultsForSearch: 5,
            ajax: {
                delay: 0,
                transport: function(params, success, failure) {
                    let pageSize = 10;
                    let term = (params.data.term || '').toLowerCase();
                    let page = (params.data.page || 1);

                    if (timer)
                        clearTimeout(timer);

                    timer = setTimeout(function(){
                        timer = null;
                        let array = Array.prototype.slice.call(that.$select[0].options)
                        let results = array.filter(function(f){
                            switch(that.props.filterType) {
                                case 'cities':
                                    let matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(term), "i");
                                    let text = $(f).text();
                                    return !term || matcher.test(text) || (text != null ? text.toLowerCase().indexOf('('+term.toLowerCase()) !== -1 : false)
                                default:
                                    return $(f).text().toLowerCase().includes(term);
                            }
                        })
                            .map(function(f){
                                return { id: $(f).val(), text: $(f).text()};
                            });

                        let paged = results.slice((page -1) * pageSize, page * pageSize);

                        let options = {
                            results: paged,
                            pagination: {
                                more: results.length >= page * pageSize
                            }
                        };
                        success(options);
                    }, params.delay);
                }
            },
        };

        if (this.clientProps.url) {
            settings.minimumInputLength = 4;
            settings.ajax = {
                url: this.props.url,
                method: 'get',
                dataType: 'json',
                delay: 400,
                cache: false,
                data: function (params) {
                    return {
                        number: params.term
                    };
                },
                processResults: function (data, rams) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item['Name'],
                                id: item['Id'],
                            };
                        })
                    };
                }
            };
        }

        return Object.assign(settings, this.props);
    }

    _afterInitialize() {
        super._afterInitialize();
        const $field = this.$container.closest('.form-item');



        this.$select.removeAttr('multiple');
        if (this.$select.options) {
            this.$select.val(null).trigger('change');
        }
        if (this.$select.val() && this.$select.val().length) {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            // $control.addClass('has-value');
        }

        let selectedValue = null;
        if (this.$container.hasClass('js-warehouse-select')) {
            this.$select.on('select2:selecting', (e) => {
                selectedValue = e.params.args.data.id;
            });

            this.$select.on('select2:close', () => {
                this.$select.val(selectedValue).trigger('change');
            });
        }

        this.$select.on('select2:open', () => {
            selectedValue = this.$select.val();
            this.$select.val(null).trigger('change');
        });

        this.$select.on('select2:select', () => {
            this.$container.addClass('custom-select2--selected');
            $field.addClass('form-item--has-value');
            this.$select[0].dispatchEvent(new Event('change'));
        });
        this.$select.on('change', () => {
            $field.toggleClass('form-item--has-value', !!this.$select.val());
        });
    }
}